import { useOutreachGmailStatus } from "@inrange/building-manager-api-client";
import { OutreachGmailConnectButton } from "./OutreachGmailConnect";

// Connecting the sending account belongs at the top of every leads page, not next to
// an individual drafted email: by the time an operator is looking at a draft the
// pipeline has already run, and connecting then means the emails they just made are
// not where they wanted them. Up here it is answered before any of that starts.
//
// It removes itself once connected - a permanent banner for a one-time action reads
// as an outstanding task forever - and stays hidden where the environment has no
// OAuth client at all, since there is nothing the operator can do about that from
// here (the drafting panel names the missing pieces for whoever is standing the
// environment up).
export const OutreachGmailHeaderPrompt: React.FC = () => {
  const statusQuery = useOutreachGmailStatus();
  const status = statusQuery.data;
  if (!status || !status.configured || status.connected) return null;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontSize: 12.5,
        color: "#664d03",
        background: "#fff3cd",
        border: "1px solid #ffe69c",
        borderRadius: 6,
        padding: "2px 8px",
      }}
    >
      Outreach drafts have nowhere to go yet.
      <OutreachGmailConnectButton label="Connect the sending account" />
    </span>
  );
};
